import { listUploadRecoveryRows } from "@/api";
import {
  DataTableSource,
  type DataTableSourceOptions,
  type DataTablePageOptions,
  type DataTablePageReq,
} from "@carbon6/c6-frontend-design";
import { UploadRecoveryTableRow } from "./UploadRecoveryTableRow";

export class UploadRecoveryTableSource extends DataTableSource<UploadRecoveryTableRow> {
  constructor(options: DataTableSourceOptions) {
    super(options);
  }

  protected override async onPage(req: DataTablePageReq, { signal }: DataTablePageOptions) {
    const response = await listUploadRecoveryRows(req, { signal });
    return { ...response, rows: response.items.map((item) => new UploadRecoveryTableRow(item)) };
  }
}
